import React, { useState } from 'react'
import { Button, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import ContentListSearchBox from 'src/components/Settings/ContentListSearchBox'
import { arrayToSentenceFragment } from 'src/components/utils'
import { useInitiativeList, usePageList, useOrganization } from 'src/graphql/hooks'

const SelectContent = ({ onContinue, onGoBack }) => {
   const [activeSearchValue, setActiveSearchValue] = useState('')
   const { organization } = useOrganization()
   const enabledInitiativeTypeNames = organization.initiativeTypes
      .filter(t => t.enabled)
      .map(t => t.nameSingular)

   const pageListFilter = {
      archived: 'exclude',
      search: activeSearchValue,
      unpublished: 'exclude',
      limit: 10
   }

   const initiativeListFilter = {
      archived: 'exclude',
      search: activeSearchValue,
      drafts: 'exclude',
      limit: 10
   }

   const {
      pageList,
      fetchMore: fetchMorePages,
      loading: pageListLoading
   } = usePageList(pageListFilter)

   const {
      initiativeList,
      fetchMore: fetchMoreInitiatives,
      loading: initiativeListLoading
   } = useInitiativeList(initiativeListFilter)

   const handleLoadMore = () => {
      fetchMorePages({
         variables: {
            start: pageList.listInfo.nextCursor
         },
         updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
               return prevResult
            }

            return {
               ...prevResult,
               pageList: {
                  ...prevResult.pageList,
                  items: [
                     ...prevResult.pageList.items,
                     ...fetchMoreResult.pageList.items
                  ],
                  listInfo: fetchMoreResult.pageList.listInfo
               }
            }
         }
      })

      fetchMoreInitiatives({
         variables: {
            start: initiativeList.listInfo.nextCursor
         },
         updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
               return prevResult
            }

            return {
               ...prevResult,
               initiativeList: {
                  ...prevResult.initiativeList,
                  items: [
                     ...prevResult.initiativeList.items,
                     ...fetchMoreResult.initiativeList.items
                  ],
                  listInfo: fetchMoreResult.initiativeList.listInfo
               }
            }
         }
      })
   }

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="18px"
            borderBottom="1px solid #eee">
            <Text size="2.5" weight="medium">
               Add Link to existing Site Content
            </Text>
         </View>
         <View padding="18px 18px 0px 18px">
            <Text size="1.5" color="#333">
               {`Select a Custom Page, ${arrayToSentenceFragment(enabledInitiativeTypeNames, 'or').trim()} to create a Main Menu link to.`}
            </Text>
         </View>
         <ContentListSearchBox
            onSubmit={setActiveSearchValue}
         />
         <View width="100%" height="220px" backgroundColor="#fafafa" scroll="on">
            {pageList.items.map(page => (
               <View
                  key={page.id}
                  display="flex"
                  padding="9px 18px"
                  borderBottom="1px solid #eee">
                  <View flex="1 1 auto">
                     <Text size="1.5" weight="medium">
                        {page.title}
                     </Text>
                     <Text size="1.5" color="#888">
                        Custom Page
                     </Text>
                  </View>
                  <View>
                     <Button
                        onClick={() => {
                           onContinue({
                              name: page.title,
                              pageId: page.id,
                              entityTypeName: 'Custom Page'
                           })
                        }}
                        name="Select"
                        size="xs"
                        color="#2e8ff4"
                        textColor="#fff"
                        width="48px"
                        rounded
                     />
                  </View>
               </View>
            ))}
            {initiativeList.items.map(initiative => (
               <View
                  key={initiative.id}
                  display="flex"
                  padding="9px 18px"
                  borderBottom="1px solid #eee">
                  <View flex="1 1 auto">
                     <Text size="1.5" weight="medium">
                        {initiative.name}
                     </Text>
                     <Text size="1.5" color="#888">
                        {initiative.type.nameSingular}
                     </Text>
                  </View>
                  <View>
                     <Button
                        onClick={() => {
                           onContinue({
                              name: initiative.name,
                              initiativeId: initiative.id,
                              entityTypeName: initiative.type.nameSingular
                           })
                        }}
                        name="Select"
                        size="xs"
                        color="#2e8ff4"
                        textColor="#fff"
                        width="48px"
                        rounded
                     />
                  </View>
               </View>
            ))}
            {(pageList.listInfo.hasNext || initiativeList.listInfo.hasNext) && (
               <View
                  float="left"
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  padding="12px 0px">
                  <Button
                     color="#000"
                     textColor="#fff"
                     size="xs"
                     onClick={handleLoadMore}
                     name="Load More"
                     mode={(pageListLoading || initiativeListLoading) ? 'loading' : 'normal'}
                     rounded
                  />
               </View>
            )}
         </View>
         <View width="100%" padding="12px" borderTop="1px solid #e5e5e5">
            <Button onClick={onGoBack} width="48%" name="Go Back" color="#eee" textColor="#333" />
         </View>
      </View>
   )
}

SelectContent.propTypes = {
   onContinue: PropTypes.func.isRequired,
   onGoBack: PropTypes.func.isRequired
}

export default SelectContent
